// paperLots — the global paper lots every surface shows (God 2026-09-24 17:44: "bots and
// supar chart kay ordar may yah lots show and fire ho"). One cached read of
// /funds/paper/lots-map (60 s), and the SAME symbol normalisation the order path uses
// (modules/paper_funds.norm_sym: MCX futures legs deploy as CRUDEOIL_FUT but orders arrive
// as CRUDEOIL), so what a card shows is what the server will fire.
import { useEffect, useState } from 'react';

const API = 'https://api.jaiswalcapital.com';
const MCX = new Set(['CRUDEOIL', 'NATURALGAS', 'GOLD', 'GOLDM', 'SILVER', 'SILVERM']);
let cache: { ts: number; data: any } | null = null;
let inflight: Promise<any> | null = null;

export const normSym = (s: string) => {
  let u = String(s || '').toUpperCase().trim().replace(/\s+/g, '_');
  if (u === 'NIFTY' || u === 'NIFTY50') u = 'NIFTY_50';
  if (u.endsWith('_FUT') && MCX.has(u.slice(0, -4))) u = u.slice(0, -4);
  return u;
};

export async function fetchLotsMap(): Promise<any> {
  if (cache && Date.now() - cache.ts < 60000) return cache.data;
  if (!inflight) {
    inflight = fetch(`${API}/funds/paper/lots-map`, { signal: AbortSignal.timeout(20000) })
      .then(r => r.json())
      .then(j => { if (j?.status === 'success') cache = { ts: Date.now(), data: j }; return cache?.data ?? null; })
      .catch(() => cache?.data ?? null)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** symbol -> { lots, lot } for every symbol with a global lots setting */
export function usePaperLots(): Record<string, { lots: number | null; lot: number | null }> {
  const [m, setM] = useState<Record<string, { lots: number | null; lot: number | null }>>({});
  useEffect(() => {
    let alive = true;
    const pull = () => fetchLotsMap().then(j => {
      if (!alive || !j) return;
      const out: Record<string, { lots: number | null; lot: number | null }> = {};
      (j.symbols || []).forEach((s: any) => { out[s.symbol] = { lots: s.lots ?? null, lot: s.lot ?? null }; });
      setM(out);
    });
    pull();
    const id = setInterval(pull, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return m;
}
